import { Row } from 'react-bootstrap';

export default Row;
